import { Link } from 'react-router-dom';

interface Props {
  title?: string;
  href?: string;
  description?: string;
  hideSeeAll?: boolean;
}

const HeaderList: React.FC<Props> = ({
  title = 'My 🧡 Rewards',
  href = '/aye-face-reward/my-rewards',
  description,
  hideSeeAll = false,
}) => {
  return (
    <div className="flex flex-col gap-y-0 p-1">
      <div className="flex items-center">
        <h2 className="flex flex-1 flex-nowrap items-center text-lg font-semibold text-gray-900">
          {title}
        </h2>
        {!hideSeeAll && (
          <Link
            to={href}
            className="flex flex-nowrap items-center gap-x-1 text-nowrap text-sm/6 !text-gray-500 hover:text-gray-400"
          >
            See all
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.25 10.5L8.75 7L5.25 3.5"
                stroke="currentColor"
                strokeOpacity="0.7"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Link>
        )}
      </div>
      {description && (
        <p className="font-base text-xs text-gray-400">{description}</p>
      )}
    </div>
  );
};
export default HeaderList;
